import { action } from 'typesafe-actions';
import { HorariosDisponiveisTypes, HorariosDisponiveis } from './types';

export const loadRequest = (
  dia: string | Date,
  codTipoCarroceria: number,
  codCdd: number,
  codEmp: number,
  ordemCarga: number
) =>
  action(HorariosDisponiveisTypes.LOAD_REQUEST, {
    dia,
    codTipoCarroceria,
    codCdd,
    codEmp,
    ordemCarga,
  });
export const loadSuccess = (data: HorariosDisponiveis[]) =>
  action(HorariosDisponiveisTypes.LOAD_SUCCESS, { data });
export const loadFailure = () => action(HorariosDisponiveisTypes.LOAD_FAILURE);

export const cleanHorariosDisponiveis = () =>
  action(HorariosDisponiveisTypes.CLEAN_HORARIOSDISPONIVEIS);
